var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4165 8.25008L18.5623 5.72925L21.0832 4.58341L18.5623 3.43758L17.4165 0.916748L16.2707 3.43758L13.7498 4.58341L16.2707 5.72925L17.4165 8.25008ZM17.4165 13.7501L16.2707 16.2709L13.7498 17.4167L16.2707 18.5626L17.4165 21.0834L18.5623 18.5626L21.0832 17.4167L18.5623 16.2709L17.4165 13.7501ZM10.5415 8.70841L8.24984 3.66675L5.95817 8.70841L0.916504 11.0001L5.95817 13.2917L8.24984 18.3334L10.5415 13.2917L15.5832 11.0001L10.5415 8.70841ZM9.15734 11.9076L8.24984 13.9059L7.34234 11.9076L5.344 11.0001L7.34234 10.0926L8.24984 8.09425L9.15734 10.0926L11.1557 11.0001L9.15734 11.9076Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.eb1ba794.svg";
export { ForwardRef as ReactComponent };